import { IsEnum, IsInt, IsNotEmpty, IsNumber, IsOptional, IsUUID, Min } from 'class-validator';
import { BotTradeStatus } from '../../enums';

export class GetBotTradesDto {
	@IsOptional()
	@IsUUID()
	market_id?: string;

	@IsOptional()
	@IsUUID()
	event_id?: string;

	@IsOptional()
	@IsEnum(BotTradeStatus)
	status?: BotTradeStatus;
}

export class StartTradingBotDto {
	@IsUUID('4')
	@IsNotEmpty()
	marketId: string;

	@IsNumber()
	value: number;

	@IsInt()
	@Min(1)
	duration_minutes: number;
}

export class BotTradeHistoryDto {
	id: string;
	market_id: string;
	event_id: string;
	target_price: number;
	initial_price: number;
	duration_minutes: number;
	start_time: Date;
	end_time: Date | null;
	status: BotTradeStatus;
	trades_made: number;
	market_question: string;
}
